export default __webpack_public_path__ + "static/media/ultrasonicV2@2x.ef4154c2.png";